import Render from '@Views/root/patients/patient/pediatrics/read-only-antecedents.html'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { IPediatrics } from '@Store/types'

@Render
@Component({})
export class ReadOnlyAntecedents extends Vue {

	@Prop() pediatrics: IPediatrics
}